module.exports = __webpack_public_path__ + "static/media/shieldImage.467405c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Protection/shieldImage.svg
// module id = 1475
// module chunks = 103